import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  FEATURE_CART_AND_PAY_AND_POST_V2,
  FEATURE_TEST_SHOPPING_CART,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import { useShoppingCart } from 'src/app/shared/hooks/useShoppingCart';
import type { AppState } from 'src/types/appState';

export const useBackfillCart = () => {
  const selectedProductId = useSelector(
    (state: AppState) => state.formData.selectedProductId,
  );

  const isCartEnabled = useFeatureToggleData(FEATURE_CART_AND_PAY_AND_POST_V2);
  const isTestingCartEnabled = useFeatureToggleData(FEATURE_TEST_SHOPPING_CART);
  const { cartState, addLineItem } = useShoppingCart();
  const shouldBackfill = isCartEnabled || isTestingCartEnabled;

  const shouldAddItemToCart = cartState?.items.length === 0;

  useEffect(() => {
    if (shouldBackfill && selectedProductId && shouldAddItemToCart) {
      addLineItem({
        productId: selectedProductId,
        // This is assuming all existing selected product in draft is of type AdProduct
        productType: 'AdProduct',
      });
    }
  }, [shouldBackfill, shouldAddItemToCart, addLineItem, selectedProductId]);
};
